import type { RemoteProductInfoQuery } from '@shared/gql/document-nodes'

export type Product = NonNullable<NonNullable<RemoteProductInfoQuery>['product']>

/** @deprecated this should be instead set to `null` in the backend */
export const NO_BRAND_BRANDNAME = 'Ei merkkiä'
export const MAX_CARTITEM_COUNT = 999
